import { Button, Row } from 'antd';
import { ErrorMessageTextStyled } from 'components/ErrorContainer/styled';
import React, { ReactElement } from 'react';
import { GeneralFunction } from 'types/common';

// NOTARY COMMISSION
const NotaryFileUploadTemplate: React.FC<{
  onClickCreateNewButton?: GeneralFunction;
  RecordCards: ReactElement[];
  createNewButtonTitle?: string;
  noDataMessage?: string;
}> = ({ RecordCards, createNewButtonTitle, onClickCreateNewButton, noDataMessage }) => (
  <>
    {onClickCreateNewButton && createNewButtonTitle && (
      <div className='gx-mt-2'>
        <Button type='dashed' onClick={onClickCreateNewButton}>
          <Row className='gx-m-0' align='middle' justify='center'>
            <span className='gx-fs-md gx-font-weight-bold gx-mr-1'> + </span>
            <span>{createNewButtonTitle}</span>
          </Row>
        </Button>
      </div>
    )}
    {RecordCards.length > 0 ? (
      <Row>{RecordCards}</Row>
    ) : (
      noDataMessage && <ErrorMessageTextStyled>{noDataMessage}</ErrorMessageTextStyled>
    )}
  </>
);

export default React.memo(NotaryFileUploadTemplate);
